namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class PartyPickerDialog extends Serenity.TemplatedDialog<any> {

        private pickerGrid: PartyPickerGrid;

        constructor() {
            super();

            this.pickerGrid = new PartyPickerGrid(this.byId("PickerGrid"));
            this.dialogTitle = "Select Parties";
        }

        protected getTemplate() {
            return `<div id="~_PickerGrid"></div>`;
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.buttons = [
                {
                    text: Q.text("Dialogs.OkButton"),
                    click: () => {
                        var selected = this.pickerGrid.selectedItems;
                        if (!selected.length) {
                            Q.notifyWarning("Please select some parties!");
                            return;
                        }

                        if (!this.onSuccess || this.onSuccess(selected))
                            this.dialogClose();
                    }
                },
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
            return opt;
        }

        get selectedItems() {
            return this.pickerGrid.selectedItems;
        }

        set criteria(value: any[]) {
            this.pickerGrid.criteria = value;
        }

        public onSuccess: (selected: PartyRow[]) => boolean;
    }
}